import React, { useEffect } from 'react';
import { CloseIcon } from '../icons/closeIcon/CloseIcon';
import {
  CloseButtonWrapper,
  DrawerContent,
  OverLayerMask,
} from './Drawer.style';

interface DrawerProps {
  onCloseDrawer: () => void;
  visible: boolean;
  children: React.ReactNode;
}

export const Drawer: React.FC<DrawerProps> = ({
  onCloseDrawer,
  visible,
  children,
}) => {
  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [visible]);

  return (
    <>
      <OverLayerMask
        onClick={onCloseDrawer}
        className={visible ? 'visible' : ''}
      />
      <DrawerContent className={visible ? 'visible' : ''}>
        <CloseButtonWrapper onClick={onCloseDrawer}>
          <CloseIcon />
        </CloseButtonWrapper>
        {children}
      </DrawerContent>
    </>
  );
};
